import T6 from "../../components/ExcerciseTypes/TypeIn/T6";
import UI from "../../components/ExcerciseTypes/Design/UserInterface";
import DesignUnderLine from "../../components/ExcerciseTypes/Design/DesignUnderLine";

const json = {
  4: { // Exercise num
    unit: "Unit 9",
    id: "SB3-U9-P5-E2",
    audio: "",
    video: "",
    component: DesignUnderLine,
    totalInput: 3,
    exerciseKey: "img/FriendsPlus/Page67/E1/Key/answerKey.png",
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page67/E1/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page67/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page67/E1/3.jpg', input: 1 },
        { url: 'img/FriendsPlus/Page67/E1/4.jpg', input: 1 },
        { url: 'img/FriendsPlus/Page67/E1/5.jpg', input: 1, isCorrect: true },
        { url: 'img/FriendsPlus/Page67/E1/6.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page67/E1/7.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page67/E1/8.jpg' },
        { url: 'img/FriendsPlus/Page67/E1/9.jpg', input: 2, isCorrect: true },
        { url: 'img/FriendsPlus/Page67/E1/10.jpg', input: 2, },
        { url: 'img/FriendsPlus/Page67/E1/11.jpg', input: 2, },
        { url: 'img/FriendsPlus/Page67/E1/12.jpg' },
        { url: 'img/FriendsPlus/Page67/E1/13.jpg', input: 3 },
        { url: 'img/FriendsPlus/Page67/E1/14.jpg', input: 3, isCorrect: true },
        { url: 'img/FriendsPlus/Page67/E1/15.jpg', input: 3 },
        { url: 'img/FriendsPlus/Page67/E1/16.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page67/E1/17.jpg' },
      ],
    ],
  },
  5: { // Exercise num
    unit: "Unit 9",
    id: "SB3-U9-P67-E2",
    audio: "",
    video: "",
    component: T6,
    exerciseKey: "img/FriendsPlus/Page67/E2/Key/answerKey.png",
    inputSize: 200,
    titleImage: 'img/FriendsPlus/Page67/E2/1.jpg',
    backgroundColor: 'transparent',
    checkUppercase: true,
    titleQuestion: [{ color: "#44509f", num: "5", title: 'Look and write.' }],
    questionImage: [],
    questions: [
      {
        title: `        
        <div style=" display: flex; flex-direction: row; ">
          <div> <img src='img/FriendsPlus/Page67/E2/2.jpg' /> </div>
          <div style=" margin: auto 20px ; ">
            <div>Does she work in a store? <u style='color: rgb(20,175,235);'>No, she doesn’t</u>.</div>
            <div>She works in a <u style='color: rgb(20,175,235);'>hospital</u> .</div>
          </div>
        </div>        
        <div style=" display: flex; flex-direction: row; ">
          <div> <img src='img/FriendsPlus/Page67/E2/3.jpg' /> </div>
          <div style=" margin: auto 20px ; ">He works in a #.</div>
        </div>        
        <div style=" display: flex; flex-direction: row; ">
          <div> <img src='img/FriendsPlus/Page67/E2/4.jpg' /> </div>
          <div style=" margin: auto 20px ; ">
            <div>Does he work in a police station? #.</div>
            <div>He works in a #.</div>
          </div>
        </div>        
        <div style=" display: flex; flex-direction: row; ">
          <div> <img src='img/FriendsPlus/Page67/E2/5.jpg' /> </div>
          <div style=" margin: auto 20px ; ">She works in a #.</div>
        </div>
        `,
        answer: ['store', "No, he doesn't.", 'fire station', 'school'],
      },
    ],
  },
  6: { // Exercise num
    unit: 'Unit 9',
    id: 'SB3-U9-P67-E3',
    audio: '',
    video: '',
    component: UI,
    titleImage: '',
    questionImage: [[{ url: 'img/FriendsPlus/Page67/E3/1.jpg' }]],
  },
}

export default json;